import { collection, getDocs, query, orderBy, limit, QueryDocumentSnapshot, DocumentData, startAfter, where } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import { LogCategory, LogLevel } from "@leedpulse-monorepo/enums";
import dayjs from "dayjs";
import { ILog } from "@leedpulse-monorepo/interfaces";

export interface LogFilters {
    id?: string;
    type?: LogLevel | null
    category?: LogCategory | null
    period?: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null;
    subscriptionId?: string;
}

async function getLogs(
    lastVisible?: QueryDocumentSnapshot<DocumentData, DocumentData>,
    filters?: LogFilters
): Promise<{
    items: ILog[],
    lastVisible: QueryDocumentSnapshot<DocumentData, DocumentData>
}> {
    try {
        const db = firestore;
        const logsCollection = collection(db, FirestoreCollections.logs);
        const constraints = [];
        if(filters) {
            // Filters on ID bypass other filters
            if (filters.id) {
                constraints.push(where('id', '==', filters.id));
            } else {
                if (filters.type) {
                    constraints.push(where('level', '==', filters.type));
                }
                if (filters.category) {
                    constraints.push(where('category', '==', filters.category));
                }
                if (filters.subscriptionId) {
                    constraints.push(where('subscriptionId', '==', filters.subscriptionId));
                }
                if (filters.period) {
                    filters.period[0] && constraints.push(where('timestamp', '>=', filters.period[0].valueOf()));
                    filters.period[1] && constraints.push(where('timestamp', '<=', filters.period[1].valueOf()));
                }
            }
        }

        // If no ID filter, apply default filters
        if (!filters?.id) {
            constraints.push(orderBy("timestamp", "desc"));
            if (lastVisible) {
                constraints.push(startAfter(lastVisible));
            }
        }
        constraints.push(limit(100));
        const results = await getDocs(query(logsCollection, ...constraints));

        const logs: ILog[] = [];

        results.docs.forEach((doc) => {
            // Custom data logs
            switch (filters?.category) {
                case LogCategory.loginasuser:
                    logs.push(doc.data() as ILog);
                    break;
                default:
                    logs.push(doc.data() as ILog);
                    break;
            }
        });

        return {
            items: logs,
            lastVisible: results.docs[results.docs.length - 1]
        };
    } catch (e) {
        console.log("error: ", e);
        throw new GetLogsFailure();
    }
}

export class GetLogsFailure extends Failure {
    constructor(message = "Unknown error", code = "unknown-error") {
        super(message, code);
    }
}

export default getLogs;
